import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let blogsSwiperWr = document.querySelectorAll('.blogs-swiper-wr');
blogsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let buttonsEl = el.querySelector('.swiper-buttons');
    let paginationEl = el.querySelector('.swiper-pagination');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');
    const updateSwiperButtonsVisibility = () => {
      if (!buttonsEl || !nextEl || !prevEl) return;

      const isNextHidden = nextEl.classList.contains('swiper-button-lock') || window.getComputedStyle(nextEl).display === 'none';
      const isPrevHidden = prevEl.classList.contains('swiper-button-lock') || window.getComputedStyle(prevEl).display === 'none';

      buttonsEl.style.display = isNextHidden && isPrevHidden ? 'none' : '';
    };
    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, Pagination],
      observer: true, //needs to calculate swiper size
      observeParents: true, //needs to calculate swiper size
      spaceBetween: 16,
      slidesPerView: 1,
      speed: 500,
      threshold: 10,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        769: {
          spaceBetween: 16,
          slidesPerView: 2,
          // slidesPerView: 4,
        },
        1024: {
          spaceBetween: 32,
          slidesPerView: 2,
          // slidesPerView: 4,
        },
        1200: {
          spaceBetween: 92,
          slidesPerView: 2,
          // slidesPerView: 4,
        },
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
        pauseOnMouseEnter: window.innerWidth >= 1033,
      },
      on:{
      afterInit: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
            requestAnimationFrame(updateSwiperButtonsVisibility);
        },

        resize: function(){
            wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') :wrapper.classList.add('justify-center')
            requestAnimationFrame(updateSwiperButtonsVisibility);
        }
      }
    });
    swiperObserver(swiper);

    const blogsTitlesArr = el.querySelectorAll('.blog-card__title');
    if (blogsTitlesArr.length) {
      lineTitlesFunc(blogsTitlesArr);
    }
  }
});
